import "./styles.scss";
import "../../global.scss";
import ProfileTopBar from "../../components/profileTopBar";
import ProfileFooter from "../../components/profileFooter";
import BannerBg from "../../assets/images/banner-bg-crop.jpg";
import SectorOffice from "../../assets/images/sector/office.jpg";
import SectorRetail from "../../assets/images/sector/retail.jpeg";
import SectorIndustry from "../../assets/images/sector/industry.jpg";
import SectorHotel from "../../assets/images/sector/hotel.jpg";
import SectorSchool from "../../assets/images/sector/classroom.jpg";
import SectorHousing from "../../assets/images/sector/house.jpg";
import SectorHospital from "../../assets/images/sector/hospital.jpg";
import SectorPublic from "../../assets/images/sector/public.jpg";
import { Grid } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import ScrollReveal from "scrollreveal";
import ClientWillmar from "../../assets/images/client/willmar.png";
import ClientAndira from "../../assets/images/client/andira.jpg";
import ClientKnp from "../../assets/images/client/KPN-Corp.png";
import ClientSuryabumi from "../../assets/images/client/suryabumi.png";
import IconExpertise from "../../assets/images/icon/expertise.png";
import IconReliabilty from "../../assets/images/icon/reliability.png";
import IconQuality from "../../assets/images/icon/quality.png";
import IconCustomer from "../../assets/images/icon/customer.png";
import IconSafety from "../../assets/images/icon/safety.png";
import IconPrice from "../../assets/images/icon/price.png";
import clientService from "../../services/client.service";
import service from "../../services/service.service";
import noImage from "../../assets/images/no-image.png";

function Home() {
  const refSlogan = useRef(null);
  const refIntro = useRef(null);
  const refSection2 = useRef(null);

  const [clientList, setClientList] = useState([]);
  const [layananList, setLayananList] = useState([]);
  const [isUpdated, setIsUpdated] = useState(0);

  useEffect(() => {
    ScrollReveal().reveal(refSlogan.current, {
      delay: 500,
      duration: 500,
      distance: "20%",
      origin: "left",
      easing: "ease",
    });
    ScrollReveal().reveal(refIntro.current, {
      delay: 600,
      duration: 500,
      distance: "20%",
      origin: "bottom",
    });
    ScrollReveal().reveal(refSection2.current, {
      delay: 100,
      distance: "10%",
      origin: "bottom",
    });
  }, []);

  useEffect(() => {
    getClient();
    getLayanan();
  }, []);

  const getClient = async () => {
    await clientService
      .listFront({ filter: "", page: 0, size: 0 })
      .then((response) => {
        setClientList(response.records);
      })
      .catch((error) => {
        alert(error);
      });
  };

  const getLayanan = async () => {
    await service
      .listFront({ filter: "", page: 0, size: 5 })
      .then((response) => {
        setLayananList(response.records);
        // setLayananTotal(response.total);
      })
      .catch((err) => {
        alert(err);
      })
      .finally(() => {});
  };

  const changeCurrentImage = (listIdx, imageIdx) => {
    let listItem = layananList;

    if (listItem[listIdx].currentImage == imageIdx) return false;
    listItem[listIdx].currentImage = imageIdx;

    setLayananList(listItem);
    setIsUpdated(isUpdated + 1);
  };

  return (
    <>
      <div className="home-page">
        <ProfileTopBar />
        <div className="top-banner-container">
          <img src={BannerBg} alt="bg" className="hidden-bg" />
          <div className="transbox"></div>
          <div className="max-1200 relative top-banner-content-container">
            <div className="top-banner-content">
              <div className="slogan" ref={refSlogan}>
                Solusi Terpercaya,
                <br /> Keunggulan dalam energi
              </div>
              <div className="small-intro" ref={refIntro}>
                Selamat datang di INDOPART, solusi komprehensif untuk kebutuhan
                mekanikal dan elektrikal Anda. Sebagai pemimpin dalam industri
                ini, kami berkomitmen untuk memberikan layanan berkualitas
                tinggi yang mengintegrasikan keahlian teknis kami dengan inovasi
                terbaru dalam teknologi.
              </div>
            </div>
          </div>
        </div>
        <div className="max-1200 drop-shadow">
          <div className="max-1200 second-section-container" ref={refSection2}>
            <Grid container spacing={0}>
              <Grid item sm={12} md={4} className="dark-green-bg">
                <div className="flex  field-padding">
                  <div className="field-icon-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="svg-icon"
                      viewBox="0 0 64 64"
                      id="worker"
                    >
                      <path
                        d="M13,37V29H41v1.79h2V29a4,4,0,0,0,1-7.87A14.89,14.89,0,0,0,31.67,7.25a5,5,0,0,0-9.34,0A15.05,15.05,0,0,0,10,21.13,4,4,0,0,0,11,29v8A16,16,0,0,0,27,53h1V51H27A14,14,0,0,1,13,37ZM22,9.35V15h2V9a3,3,0,0,1,6,0v6h2V9.35A12.91,12.91,0,0,1,41,17H34v2h7.65A13.22,13.22,0,0,1,42,21H12A13.07,13.07,0,0,1,22,9.35ZM9,25a2,2,0,0,1,2-2H43a2,2,0,0,1,0,4H11A2,2,0,0,1,9,25ZM55,42H51.66L54,39.64a1,1,0,0,0,0-1.42L49.78,34a1,1,0,0,0-1.42,0L46,36.34V33a1,1,0,0,0-1-1H39a1,1,0,0,0-1,1v3.34L35.64,34a1,1,0,0,0-1.42,0L30,38.22a1,1,0,0,0,0,1.42L32.34,42H29a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h3.34L30,52.36a1,1,0,0,0,0,1.42L34.22,58a1,1,0,0,0,1.42,0L38,55.66V59a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V55.66L48.36,58a1,1,0,0,0,1.42,0L54,53.78a1,1,0,0,0,0-1.42L51.66,50H55a1,1,0,0,0,1-1V43A1,1,0,0,0,55,42Zm-1,6H50.48a1,1,0,0,0-.95.67,7.35,7.35,0,0,1-.32.77,1,1,0,0,0,.2,1.14l2.49,2.49L49.07,55.9l-2.49-2.49a1,1,0,0,0-1.14-.2,7.35,7.35,0,0,1-.77.32,1,1,0,0,0-.67.95V58H40V54.48a1,1,0,0,0-.67-.95,7.35,7.35,0,0,1-.77-.32,1,1,0,0,0-1.14.2L34.93,55.9,32.1,53.07l2.49-2.49a1,1,0,0,0,.2-1.14,7.35,7.35,0,0,1-.32-.77,1,1,0,0,0-.95-.67H30V44h3.52a1,1,0,0,0,.95-.67,7.35,7.35,0,0,1,.32-.77,1,1,0,0,0-.2-1.14L32.1,38.93l2.83-2.83,2.49,2.49a1,1,0,0,0,1.14.2,7.35,7.35,0,0,1,.77-.32,1,1,0,0,0,.67-.95V34h4v3.52a1,1,0,0,0,.67.95,7.35,7.35,0,0,1,.77.32,1,1,0,0,0,1.14-.2l2.49-2.49,2.83,2.83-2.49,2.49a1,1,0,0,0-.2,1.14,7.35,7.35,0,0,1,.32.77,1,1,0,0,0,.95.67H54ZM42,40a6,6,0,1,0,6,6A6,6,0,0,0,42,40Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,42,50ZM30,17h2v2H30Z"
                        data-name="13 Helmet Gear, Construction, Engineering"
                      ></path>
                    </svg>
                  </div>
                  <div className="text-left field-desc-container">
                    <div className="field-title bold">Pekerja Handal</div>
                    <div className="field-desc">
                      Ketika datang ke keberhasilan proyek atau bisnis, tidak
                      ada yang lebih berharga daripada memiliki tim pekerja yang
                      handal.
                    </div>
                  </div>
                </div>
              </Grid>
              <Grid item sm={12} md={4} className="flex orange-bg">
                <div className="flex orange-bg field-padding">
                  <div className="field-icon-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="svg-icon2"
                      viewBox="0 0 64 64"
                      id="construction"
                    >
                      <path d="M53,20H8a1,1,0,0,1-1-1V17a1,1,0,0,1,.28-.7l2.92-3a1,1,0,0,1,.72-.3H47.17a1,1,0,0,1,.46.11l5.83,3A1,1,0,0,1,54,17v2A1,1,0,0,1,53,20ZM9,18H52v-.39L46.93,15H11.34L9,17.41Z"></path>
                      <path d="M20.92 15H15a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h2a1 1 0 0 1 .84.45l3.92 6a1 1 0 0 1 0 1A1 1 0 0 1 20.92 15zM16 13h3.07L16.46 9H16zM21 52H15a1 1 0 0 1-1-1V19a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1V51A1 1 0 0 1 21 52zm-5-2h4V20H16zM56 57H32a1 1 0 0 1-1-1V43a1 1 0 0 1 1-1H43V37a1 1 0 0 1 1-1H56a1 1 0 0 1 1 1V56A1 1 0 0 1 56 57zM33 55H55V38H45v5a1 1 0 0 1-1 1H33z"></path>
                      <path d="M34 44a1 1 0 0 1-1-1V34a1 1 0 0 1 2 0v9A1 1 0 0 1 34 44zM44 44a1 1 0 0 1-1-1V29a1 1 0 0 1 2 0V43A1 1 0 0 1 44 44zM54 38a1 1 0 0 1-1-1V27a1 1 0 0 1 2 0V37A1 1 0 0 1 54 38z"></path>
                      <path d="M44 40H34a1 1 0 0 1 0-2H44a1 1 0 0 1 0 2zM54 34H44a1 1 0 0 1 0-2H54a1 1 0 0 1 0 2z"></path>
                      <path d="M39 44a1 1 0 0 1-1-1V36a1 1 0 0 1 2 0v7A1 1 0 0 1 39 44zM49 38a1 1 0 0 1-1-1V30a1 1 0 0 1 2 0v7A1 1 0 0 1 49 38zM40 32H26a1 1 0 0 1-1-1V27a1 1 0 0 1 1-1H40a1 1 0 0 1 1 1v4A1 1 0 0 1 40 32zM27 30H39V28H27z"></path>
                      <path d="M33 28a1 1 0 0 1-1-1V19a1 1 0 0 1 2 0v8A1 1 0 0 1 33 28zM24 57H12a1 1 0 0 1-1-1V51a1 1 0 0 1 1-1H24a1 1 0 0 1 1 1v5A1 1 0 0 1 24 57zM13 55H23V52H13z"></path>
                      <path d="M15,51a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42l6-6a1,1,0,0,1,1.42,1.42l-6,6A1,1,0,0,1,15,51Z"></path>
                      <path d="M21,45a1,1,0,0,1-.71-.29l-6-6a1,1,0,0,1,1.42-1.42l6,6a1,1,0,0,1,0,1.42A1,1,0,0,1,21,45Z"></path>
                      <path d="M15 39a1 1 0 0 1-.71-.29 1 1 0 0 1 0-1.42l6-6a1 1 0 0 1 1.42 1.42l-6 6A1 1 0 0 1 15 39zM15 27a1 1 0 0 1-.71-.29 1 1 0 0 1 0-1.42l6-6a1 1 0 0 1 1.42 1.42l-6 6A1 1 0 0 1 15 27z"></path>
                      <path d="M21,33a1,1,0,0,1-.71-.29l-6-6a1,1,0,0,1,1.42-1.42l6,6a1,1,0,0,1,0,1.42A1,1,0,0,1,21,33Z"></path>
                    </svg>
                  </div>
                  <div className="text-left field-desc-container">
                    <div className="field-title bold">Berkualitas</div>
                    <div className="field-desc">
                      Dalam dunia bisnis yang semakin kompetitif, keunggulan
                      kualitas menjadi kunci untuk membedakan suatu perusahaan
                      dari yang lain.
                    </div>
                  </div>
                </div>
              </Grid>
              <Grid item sm={12} md={4} className="dark-green-bg">
                <div className="flex dark-green-bg field-padding">
                  <div className="field-icon-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="svg-icon"
                      data-name="Layer 1"
                      viewBox="0 0 512 512"
                      id="customer-support"
                    >
                      <path d="m474.03 473.837-7.013-58.066a7.076 7.076 0 0 0-.041-.289 58.562 58.562 0 0 0-46.859-48.143l-71.52-13.453h-.005l-19.37-3.644a392.654 392.654 0 0 0 55.293-15.005 36.93 36.93 0 0 0 24.27-40.069l-11.16-76.507h6.226a15.07 15.07 0 0 0 15.053-15.054v-30.563a15.07 15.07 0 0 0-15.053-15.054h-12.38a33.364 33.364 0 0 0-3.649-6.533l-6.225-42.68A127.149 127.149 0 0 0 255.767 0h-5.642a127.356 127.356 0 0 0-126.172 111.302l-5.857 46.688H105.85a15.07 15.07 0 0 0-15.054 15.054v30.563a15.07 15.07 0 0 0 15.054 15.054h4.636l-9.67 77.085a37.011 37.011 0 0 0 24.208 39.281 391.678 391.678 0 0 0 57.05 15.443l-16.502 3.245-.111.022-70.709 13.905a58.498 58.498 0 0 0-45.55 43.888q-.048.197-.083.396l-10.697 59.612A33.08 33.08 0 0 0 70.67 512h370.66a33.09 33.09 0 0 0 32.7-38.163Zm-79.995-300.824 9.87.03-.054 30.618h-9.816Zm-9.976 56.567 9.882 67.754a21.898 21.898 0 0 1-14.405 23.753 377.475 377.475 0 0 1-63.916 16.358v-28.919l5.425-3.394a60.96 60.96 0 0 0 19.503-19.498h1.224a32.7 32.7 0 0 0 32.667-32.658v-16.77a33.466 33.466 0 0 0 9.62-6.626Zm-100.09 81.056a55.259 55.259 0 0 1-58.236 0l-15.549-9.728c-.025-.017-.053-.032-.079-.049l-13.5-8.446a45.706 45.706 0 0 1-21.602-38.98V151.94a50.302 50.302 0 0 0 36.03-23.519 115.656 115.656 0 0 0 15.446 12.82l1.456.991c34.128 23.131 70.971 17.74 106.76 11.606v99.597a46.092 46.092 0 0 1-3.306 17.2h-50.288a22.195 22.195 0 0 0-20.899-14.801h-12.737a22.186 22.186 0 0 0-22.16 22.161v.28a22.186 22.186 0 0 0 22.16 22.16h12.737a22.196 22.196 0 0 0 20.899-14.8h40.432a46.389 46.389 0 0 1-8.442 6.78Zm16.651 7.276v34.148a5.638 5.638 0 0 1-2.167 4.421l-42.36 32.97-40.538-32.876a5.57 5.57 0 0 1-2.04-3.718c-.004-.055-.004-.11-.009-.164-.012-.153-.026-.307-.026-.463v-31.565l4.3 2.69a70.351 70.351 0 0 0 74.143-.002Zm-33.258-39.918v.28a7.168 7.168 0 0 1-7.16 7.16h-12.737a7.168 7.168 0 0 1-7.16-7.16v-.28a7.169 7.169 0 0 1 7.16-7.161h12.737a7.169 7.169 0 0 1 7.16 7.161Zm80.16-8.34a61.453 61.453 0 0 0 2.173-16.22v-14.23h9.744v13.772a17.675 17.675 0 0 1-11.917 16.679Zm31.513-98.844v35.031a18.383 18.383 0 0 1-18.362 18.363h-10.978v-71.757h10.978a18.383 18.383 0 0 1 18.362 18.363Zm-240.2-57.641A112.332 112.332 0 0 1 250.126 15h5.642a112.147 112.147 0 0 1 110.986 95.941l4.1 28.103a33.215 33.215 0 0 0-10.18-1.597h-18.1c-.037-.001-.073.002-.11 0h-.268l-.03.002a7.406 7.406 0 0 0-.7.036l-.1.011c-.144.016-.287.025-.43.05l-5.134.881c-35.567 6.127-69.162 11.914-99.45-8.612l-1.365-.93a100.174 100.174 0 0 1-20.188-18.55 7.5 7.5 0 0 0-12.918 2.46 35.594 35.594 0 0 1-34.3 24.653l-.033.001-.044-.002h-18.477a33.128 33.128 0 0 0-13.603 2.926Zm-8.17 57.64a18.383 18.383 0 0 1 18.361-18.361h10.977v71.756h-10.977a18.383 18.383 0 0 1-18.362-18.363Zm-24.87 32.798.054-30.617h9.815v30.648Zm24.232 117.28a21.924 21.924 0 0 1-14.329-23.274l8.696-69.322a33.258 33.258 0 0 0 24.632 10.913h10.977v14.23a60.621 60.621 0 0 0 28.648 51.697l9.83 6.15v26.799a376.572 376.572 0 0 1-68.454-17.193Zm70.935 41.156a20.614 20.614 0 0 0 5.144 6.183l41.47 33.63a13.417 13.417 0 0 0 16.79.163l43.297-33.698a20.547 20.547 0 0 0 5.138-5.904l25.975 4.885a15.708 15.708 0 0 1-5.206 7.436l-77.163 60.055a1.768 1.768 0 0 1-2.206-.023l-73.92-59.952a15.458 15.458 0 0 1-5.112-7.703ZM455.1 490.645A18.067 18.067 0 0 1 441.33 497H70.67a18.08 18.08 0 0 1-17.6-22.228q.046-.197.081-.398l10.694-59.592a43.468 43.468 0 0 1 33.802-32.423l62.756-12.34a30.394 30.394 0 0 0 10.435 16.454l73.919 59.95a16.7 16.7 0 0 0 20.87.202l77.164-60.055a30.44 30.44 0 0 0 10.82-16.477l63.729 11.987a43.525 43.525 0 0 1 34.803 35.64l7.01 58.05c.012.095.026.19.041.286a18.055 18.055 0 0 1-4.095 14.589Z"></path>
                    </svg>
                  </div>
                  <div className="text-left field-desc-container">
                    <div className="field-title bold">24/7 Support</div>
                    <div className="field-desc">
                      Dalam era di mana kebutuhan pelanggan tidak mengenal
                      waktu, penyedia layanan yang menawarkan dukungan 24/7
                      menjadi kebutuhan mutlak.
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
          <div className="max-1200 service-section-container">
            <div className="service-section-title">LAYANAN KAMI</div>
            <div className="service-section-subtitle">
              Layanan yang Kami siapkan
            </div>
            <div className="service-section-content">
              <div className="max-1200 separator-container">
                <div className="separator"></div>
              </div>
              {layananList.map((item, idx) => {
                if (idx % 2 == 0) {
                  return (
                    <>
                      <div
                        className="max-1200 mechanic-container"
                        id={item.title}
                      >
                        <Grid
                          container
                          spacing={{ xs: 2, md: 8 }}
                          justifyContent="center"
                          alignItems="center"
                          className="service-grid"
                        >
                          <Grid
                            item
                            xs={12}
                            sm={5}
                            md={4}
                            className="service-item-image-container"
                          >
                            <div className="preview-container">
                              {item.imageList.length > 0 && (
                                <img
                                  src={item.imageList[item.currentImage]}
                                  alt={item.name + item.currentImage}
                                  className="service-item-image"
                                />
                              )}
                              {item.imageList.length == 0 && (
                                <img
                                  src={noImage}
                                  alt="no image"
                                  className="service-item-image"
                                />
                              )}
                            </div>
                            {item.imageList.length > 0 && (
                              <div className="thumbnail-container">
                                {item.imageList.map((item2, idx2) => (
                                  <img
                                    key={idx2}
                                    src={item2}
                                    alt={"img" + idx2}
                                    className="thumbnail-img"
                                    onClick={() =>
                                      changeCurrentImage(idx, idx2)
                                    }
                                  />
                                ))}
                              </div>
                            )}
                          </Grid>
                          <Grid item xs={12} sm={7} md={8}>
                            <div className="mechanic-title text-yellow text-left">
                              {item.title}
                            </div>
                            <div
                              className="mechanic-desc text-justify"
                              dangerouslySetInnerHTML={{ __html: item.desc }}
                            ></div>
                          </Grid>
                        </Grid>
                      </div>
                      <div className="max-1200 separator-container">
                        <div className="separator"></div>
                      </div>
                    </>
                  );
                } else {
                  return (
                    <>
                      <div
                        className="max-1200 electric-container"
                        id={item.title}
                      >
                        <Grid
                          container
                          spacing={{ xs: 2, md: 8 }}
                          justifyContent="center"
                          alignItems="center"
                          className="service-grid electric-desktop"
                        >
                          <Grid item xs={12} sm={7} md={8}>
                            <div className="electric-title text-yellow text-left">
                              {item.title}
                            </div>
                            <div
                              className="electric-desc text-justify"
                              dangerouslySetInnerHTML={{ __html: item.desc }}
                            ></div>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={5}
                            md={4}
                            className="service-item-image-container"
                          >
                            <div className="preview-container">
                              {item.imageList.length > 0 && (
                                <img
                                  src={item.imageList[item.currentImage]}
                                  alt={item.name + item.currentImage}
                                  className="service-item-image"
                                />
                              )}
                              {item.imageList.length == 0 && (
                                <img
                                  src={noImage}
                                  alt="no image"
                                  className="service-item-image"
                                />
                              )}
                            </div>
                            {item.imageList.length > 0 && (
                              <div className="thumbnail-container">
                                {item.imageList.map((item2, idx2) => (
                                  <img
                                    key={idx2}
                                    src={item2}
                                    alt={"img" + idx2}
                                    className="thumbnail-img"
                                    onClick={() =>
                                      changeCurrentImage(idx, idx2)
                                    }
                                  />
                                ))}
                              </div>
                            )}
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          spacing={{ xs: 2, md: 8 }}
                          justifyContent="center"
                          alignItems="center"
                          className="service-grid electric-mobile"
                        >
                          <Grid
                            item
                            xs={12}
                            sm={5}
                            md={4}
                            className="service-item-image-container"
                          >
                            <div className="preview-container">
                              {item.imageList.length > 0 && (
                                <img
                                  src={item.imageList[item.currentImage]}
                                  alt={item.name + item.currentImage}
                                  className="service-item-image"
                                />
                              )}
                              {item.imageList.length == 0 && (
                                <img
                                  src={noImage}
                                  alt="no image"
                                  className="service-item-image"
                                />
                              )}
                            </div>
                            {item.imageList.length > 0 && (
                              <div className="thumbnail-container">
                                {item.imageList.map((item2, idx2) => (
                                  <img
                                    key={idx2}
                                    src={item2}
                                    alt={"img" + idx2}
                                    className="thumbnail-img"
                                    onClick={() =>
                                      changeCurrentImage(idx, idx2)
                                    }
                                  />
                                ))}
                              </div>
                            )}
                          </Grid>
                          <Grid item xs={12} sm={7} md={8}>
                            <div className="electric-title text-yellow text-left">
                              {item.title}
                            </div>
                            <div
                              className="electric-desc text-justify"
                              dangerouslySetInnerHTML={{ __html: item.desc }}
                            ></div>
                          </Grid>
                        </Grid>
                      </div>
                      <div className="max-1200 separator-container">
                        <div className="separator"></div>
                      </div>
                    </>
                  );
                }
              })}
            </div>
          </div>
          <div className="max-1200 why-section-container">
            <div className="why-section-title">MENGAPA MEMILIH KAMI?</div>
            <div className="why-section-subtitle">
              Alasan untuk memilih kami
            </div>
            <div className="why-section-content">
              <Grid
                container
                spacing={{ xs: 2, md: 8 }}
                justifyContent="center"
              >
                <Grid item xs={12} sm={4}>
                  <div className="why-icon">
                    <img src={IconExpertise} alt="expertise" />
                  </div>
                  <div className="why-title text-dark-green">Pengalaman</div>
                  <div className="why-desc">
                    Dengan pengalaman industri selama lebih dari 10 tahun, kami
                    membawa banyak manfaat pengetahuan dan keahlian untuk setiap
                    proyek yang kami lakukan.
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div className="why-icon">
                    <img src={IconReliabilty} alt="reliabilty" />
                  </div>
                  <div className="why-title text-dark-green">Keandalan</div>
                  <div className="why-desc">
                    Rekam jejak kami dalam proyek-proyek yang sukses menunjukkan
                    keandalan kami.
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div className="why-icon">
                    <img src={IconQuality} alt="quality" />
                  </div>
                  <div className="why-title text-dark-green">
                    Tim berkualitas &amp; teknologi mutakhir
                  </div>
                  <div className="why-desc">
                    Tim kami terdiri dari para profesional berkualitas yang
                    berdedikasi pada keunggulan, menggunakan teknologi terbaru
                    untuk memberikan solusi yang efisien.
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div className="why-icon">
                    <img src={IconCustomer} alt="customer" />
                  </div>
                  <div className="why-title text-dark-green">
                    Kepuasan pelanggan
                  </div>
                  <div className="why-desc">
                    Kepuasan Anda adalah prioritas utama kami. Kami bekerja sama
                    dengan Anda untuk memahami visi, tujuan, dan harapan Anda,
                    memastikan bahwa proyek Anda melampaui impian terliar Anda.
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div className="why-icon">
                    <img src={IconSafety} alt="safety" />
                  </div>
                  <div className="why-title text-dark-green">
                    Utamakan keselamatan
                  </div>
                  <div className="why-desc">
                    Kami mematuhi protokol keselamatan untuk memastikan
                    kesejahteraan klien.
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div className="why-icon">
                    <img src={IconPrice} alt="price" />
                  </div>
                  <div className="why-title text-dark-green">
                    Harga bersaing
                  </div>
                  <div className="why-desc">
                    Layanan kami diberi harga bersaing tanpa mengorbankan
                    kualitas.
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
          <ProfileFooter />
        </div>
      </div>
    </>
  );
}
export default Home;
